<script>
export default {
  props: ['attrs', 'value'],
};
</script>
